import { subject } from "@casl/ability";
import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import useUserStore from "@/modules/users/store";
import { getAllMedias, QUERY_KEY_MEDIA } from "../../firestore";

type TGetRespostasResponse = Awaited<ReturnType<typeof getAllMedias>>;

/**
 * Get all medias query hook
 * @returns Medias query hook
 */
function useQueryAllMedias() {
  const activeEmpresaId = useUserStore((store) => store.activeEmpresaId);

  return useQuery<TGetRespostasResponse, FirestoreError, TMedia[]>({
    queryKey: ["empresas", { id: activeEmpresaId }, QUERY_KEY_MEDIA, "all"],
    queryFn() {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }

      return getAllMedias(activeEmpresaId);
    },
    select(dataResponse) {
      if (dataResponse.empty) {
        return [];
      }
      return dataResponse.docs.map((document_) => subject("TMedia", document_.data()));
    },
    enabled: !!activeEmpresaId
  });
}

export default useQueryAllMedias;
